import ApiService from "../../../ApiService";

export const getMessageCount = async (_cb) => {
  try {
    const response = await ApiService.getMessageCount();
    if (_cb && typeof _cb === "function") {
      _cb({
        success: true,
        data: response.data
      });
    }
  } catch (error) {
    if (_cb && typeof _cb === "function") {
      _cb({
        success: false,
        data: error?.response?.data
      });
    }
    console.log("Error while calling api", error);
  }
};
export const getBookingByDate = async (date, _cb) => {
  try {
    const response = await ApiService.getAppointmentByDate(date);
    if (_cb && typeof _cb === "function") {
      _cb({
        success: true,
        data: response.data
      });
    }
  } catch (error) {
    if (_cb && typeof _cb === "function") {
      _cb({
        success: false,
        data: error?.response?.data
      });
    }
    console.log("Error while calling api", error);
  }
};
export const getTestResultWithStatus = async (status, _cb) => {
  try {
    const response = await ApiService.getTestResultWithStatus(status);
    if (_cb && typeof _cb === "function") {
      _cb({
        success: true,
        data: response.data
      });
    }
  } catch (error) {
    if (_cb && typeof _cb === "function") {
      _cb({
        success: false,
        data: error?.response?.data
      });
    }
    console.log("Error while calling api", error);
  }
};
export const getKitByStatus = async (status, _cb) => {
  try {
    const response = await ApiService.getKitByStatus(status);
    if (_cb && typeof _cb === "function") {
      _cb({
        success: true,
        data: response.data
      });
    }
  } catch (error) {
    if (_cb && typeof _cb === "function") {
      _cb({
        success: false,
        data: error?.response?.data
      });

      console.log("Error while calling api", error);
    }
  }
};
export const getOrderByStatus = async (status, _cb) => {
  try {
    const response = await ApiService.getOrderByStatus(status);
    if (_cb && typeof _cb === "function") {
      _cb({
        success: true,
        data: response.data
      });
    }
  } catch (error) {
    if (_cb && typeof _cb === "function") {
      _cb({
        success: false,
        data: error?.response?.data
      });
    }
    console.log("Error while calling api", error);
  }
};
